module.exports = __webpack_public_path__ + "img/dashboard.9065258.svg";